<template>
  <div>
      广告分类
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>